<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6923 1C19.4624 1 20.9012 2.40677 20.9951 4.16938L21 4.35294V19.6471C21 21.433 19.6203 22.8993 17.8742 22.995L17.6923 23H5C4.44772 23 4 22.5523 4 22C4 21.4872 4.38604 21.0645 4.88338 21.0067L5 21H17.6923C18.3679 21 18.9302 20.4672 18.994 19.778L19 19.6471V4.35294C19 3.64564 18.4775 3.07128 17.8176 3.00615L17.6923 3H5C4.44772 3 4 2.55228 4 2C4 1.48716 4.38604 1.06449 4.88338 1.00673L5 1H17.6923Z"
      :fill="color"
    />
    <path
      d="M11.5852 13L9.29289 15.2929L9.2097 15.3871C8.90468 15.7794 8.93241 16.3466 9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071L14.7071 12.7071L14.7903 12.6129C15.0953 12.2206 15.0676 11.6534 14.7071 11.2929L10.7071 7.29289L10.6129 7.2097C10.2206 6.90468 9.65338 6.93241 9.29289 7.29289L9.2097 7.3871C8.90468 7.77939 8.93241 8.34662 9.29289 8.70711L11.5852 11H3L2.88338 11.0067C2.38604 11.0645 2 11.4872 2 12C2 12.5523 2.44772 13 3 13H11.5852Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'LoggedInIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
